import algoliasearch from "algoliasearch";

const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID || "";
const ALGOLIA_SEARCH_API_KEY =
  process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY || "";

export const searchAlgoliaClient = algoliasearch(
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY,
);

export const searchGamesIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME || "",
);

export const searchSupportTicketsIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_CUSTOMER_SUPPORT_TICKETS_INDEX_NAME || "",
);

export const searchBroadcastsIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_BROADCASTS_INDEX_NAME || "",
);
